import { useMemo } from "react"

import type { MetricDirectoryEntryResource } from "@/types_api/backend/transport/list_metric_directory_response"

import { useMetricDirectoryTransport } from "../routes/useMetricDirectoryTransport"

export type MetricDirectoryEntry = MetricDirectoryEntryResource

interface UseMetricDirectoryResult {
  entries: MetricDirectoryEntry[]
  byManager: Record<string, MetricDirectoryEntry>
  entry: MetricDirectoryEntry | undefined
  error: unknown
  refetch: () => Promise<unknown>
  isLoading: boolean
}

export function useMetricDirectory(
  metricManager?: string,
): UseMetricDirectoryResult {
  const { data, isLoading, error, refetch } = useMetricDirectoryTransport()

  const entries = useMemo<MetricDirectoryEntry[]>(
    () => data?.entries ?? [],
    [data],
  )

  const byManager = useMemo(() => {
    const index: Record<string, MetricDirectoryEntry> = {}
    for (const item of entries) {
      index[item.metric_manager] = item
    }
    return index
  }, [entries])

  const entry = metricManager ? byManager[metricManager] : undefined

  return { entries, byManager, entry, isLoading, error, refetch }
}
